export const getUserToken = () => sessionStorage.getItem('@Frotabank:token');

export const setUserToken = value =>
  sessionStorage.setItem('@Frotabank:token', value);
